import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { ArrowBackOutlined } from "@mui/icons-material/";
import UsinaLocationMap from "../../portfolio/components/UsinaLocationMap";
import { usinasApi } from "../../../services/api";
import Loading from "../../../main/components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { IndicatorsDataModal } from "./IndicatorsDataModal";
import { UsinasContext } from "../context/UsinasContextProvider";
import { EditUsinaNameModal } from "./EditUsinaNameModal";
import { EditUsinaLocationModal } from "./EditUsinaLocationModal";
import ComponentsChart from "./ComponentsChart";
import { SupportDataModal } from "./SupportDataModal";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DeleteIcon from "@mui/icons-material/Delete";

import EditUsinaContent from "./EditUsinaContent";
import { MainContext } from "../../../main/context/MainContextProvider";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
// import { EditUsinaCodigoModal } from "./EditUsinaCodigoModal ";

export default function UsinaDetails() {
  const navigate = useNavigate();
  const { usina, setUsina } = useContext(UsinasContext);
  const { userIsAdm, userIsClient, selectedDashboardUsina } = useContext(MainContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [showIndicatorsDataModal, setShowIndicatorsDataModal] = useState(false);
  const [showSupportDataModal, setShowSupportDataModal] = useState(false);
  const [showEditNameModal, setShowEditNameModal] = useState<boolean>(false);
  // const [showEditCodeModal, setShowEditCodeModal] = useState<boolean>(false);
  const [showEditLocationModal, setShowEditLocationModal] =
    useState<boolean>(false);
  const [isChartVisible, setIsChartVisible] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [openDeleteErrorModal, setOpenDeleteErrorModal] = useState(false);
  const [openDeleteSuccessModal, setOpenDeleteSuccessModal] = useState(false);

  const path = window.location.pathname;

  useEffect(() => {
    if (path.includes("usinas/details"))
      navigate(`/usinas/details/${selectedDashboardUsina?.usinaIds.id}`);
  }, [selectedDashboardUsina]);

  const handleOpenChart = () => {
    setIsChartVisible(true);
    setDialogOpen(true);
  };

  const handleCloseChart = () => {
    setIsChartVisible(false);
    setDialogOpen(false);
  };
  const [usinaId, setUsinaId] = useState<string>("");

  useEffect(() => {
    if (path.includes("usinas/details")) {
      setUsinaId(path.split("/")[3]);
    }
    else { setUsinaId(path.split("/")[2]); }
  }, [path])

  useEffect(() => {
    onMount();
  }, [usinaId]);

  const onMount = async () => {
    setLoading(true);
    try {
      if (usinaId) {
        const usinaResponse = await usinasApi.getUsina(usinaId);
        setUsina(usinaResponse);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        ("Erro ao coletar os dados da usina");
      }
    } finally {
      setLoading(false);
    }
  };

  const openIndicatorsDataModal = () => {
    setShowIndicatorsDataModal(true);
  };
  const openSupportDataModal = () => {
    setShowSupportDataModal(true);
  };
  const latitude =
    usina?.location?.latitude && usina?.location?.latitude != 0
      ? usina?.location?.latitude
      : undefined;
  const longitude =
    usina?.location?.longitude && usina?.location?.longitude != 0
      ? usina?.location?.longitude
      : undefined;
  const hasLocation = latitude && longitude ? true : false;

  const [, setDialogOpen] = useState(false);

  // const handleOpenDialog = () => {
  //   setDialogOpen(true);
  // };

  // const handleCloseDialog = () => {
  //   setDialogOpen(false);
  // };

  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        maxHeight: "100vh",
      }}
    >
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {usina && (
            <>
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "20px",
                  }}
                >
                  <Grid
                    item
                    display={"flex"}
                    alignItems={"center"}
                    xs={12}
                    md={6}
                    justifyContent={"start"}
                  >
                    <IconButton
                      onClick={() => {
                        navigate("/usinas/");
                      }}
                      sx={{
                        marginRight: "20px",
                      }}
                    >
                      <ArrowBackOutlined />
                    </IconButton>
                    <Grid>
                      <Typography
                        sx={{
                          marginRight: "10px",
                          fontWeight: "bold",
                          fontSize: "1.5em",
                        }}
                      >
                        {usina.name}
                      </Typography>

                      <Typography
                        sx={{
                          marginRight: "10px",
                          fontWeight: "bold",
                          fontSize: "0.9em",
                        }}
                      >
                        {usina.code}
                        {/* <Tooltip title="Editar Código da Usina">
                          <IconButton
                            size="small"
                            onClick={() => setShowEditCodeModal(true)}
                            sx={{ marginLeft: "5px" }}
                          >
                            <FontAwesomeIcon size="sm" icon={faPen} />
                          </IconButton>
                        </Tooltip> */}
                      </Typography>
                    </Grid>
                    {(userIsAdm || userIsClient) && (
                      <Tooltip title="Editar Nome da Usina">
                        <IconButton
                          size="small"
                          onClick={() => setShowEditNameModal(true)}
                          sx={{ marginTop: "-20px" }}
                        >
                          <FontAwesomeIcon size="sm" icon={faPen} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Grid>
                  <Typography
                    sx={{
                      marginRight: "10px",
                      fontWeight: "bold",
                      fontSize: "0.9em",
                    }}
                  >
                    {usina.clusterName}
                  </Typography>
                </Grid>
              </Grid>

              {/*Botões */}
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  padding: "20px",
                }}
              >
                <Grid item xs={12} md={4} xl={2}>
                  <PrimaryBaseButton
                    onClick={handleOpenChart}
                    startIcon={<AccountTreeIcon />}
                    // startIcon={
                    //   <PiTreeStructureBold
                    //     color="#ff9f0c"
                    //     style={{
                    //       ":hover": {
                    //         color: "#ffffff",
                    //       },
                    //     }}
                    //   />
                    // }
                    title="Árvore"
                    sx={{ width: "100%" }}
                  />
                  {isChartVisible && (
                    <ComponentsChart
                      onClose={handleCloseChart}
                      open={isChartVisible}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={4} xl={2}>
                  <PrimaryBaseButton
                    onClick={openIndicatorsDataModal}
                    startIcon={<ShowChartIcon />}
                    title="Dados de Indicadores"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} md={4} xl={2}>
                  <PrimaryBaseButton
                    onClick={openSupportDataModal}
                    title="Suporte"
                    startIcon={<HeadsetMicIcon />}
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} md={6} sx={{ paddingX: "20px", maxHeight: "400px", overflow: "auto" }}>
                  <EditUsinaContent />
                </Grid>

                <Grid
                  item
                  xs={12} md={6}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "8px",
                    paddingX: "20px",
                  }}
                >
                  {hasLocation ? (
                    <UsinaLocationMap
                      latitude={latitude as number}
                      longitude={longitude as number}
                      width="100%"
                      height="400px"
                      onClickEditLocation={() => {
                        setShowEditLocationModal(true);
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        width: "100%",
                        height: "200px",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        Usina sem localização
                      </Typography>
                      <Typography variant="body1" gutterBottom>
                        Para adicionar uma localização para esta usina, clique no
                        botão abaixo
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setShowEditLocationModal(true);
                        }}
                      >
                        Adicionar Localização
                      </Button>
                    </Box>
                  )}
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "30px",
                    paddingBottom: "30px"
                  }}
                >
                  <DangerBaseButton
                    startIcon={<DeleteIcon />}
                    title={"Deletar Usina"}
                    onClick={() => setShowDeleteModal(true)}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </>
      )}

      <IndicatorsDataModal
        open={showIndicatorsDataModal}
        setOpen={setShowIndicatorsDataModal}
      />
      <EditUsinaNameModal
        open={showEditNameModal}
        setOpen={setShowEditNameModal}
      />
      {/* <EditUsinaCodigoModal
        open={showEditCodeModal}
        setOpen={setShowEditCodeModal}
      /> */}

      <EditUsinaLocationModal
        open={showEditLocationModal}
        setOpen={setShowEditLocationModal}
      />
      <SupportDataModal
        open={showSupportDataModal}
        setOpen={setShowSupportDataModal}
      />
      <ConfirmationModal
        contentText={"Deseja confirmar a exclusão?"
        }
        title={"Excluir Usina"}
        open={showDeleteModal}
        setOpen={setShowDeleteModal}
        onConfirm={async () => {
          await usinasApi.deleteUsina(usina?.usinaIds.id ?? "");
        }}
        setOpenErrorModal={setOpenDeleteErrorModal}
        setOpenSuccessModal={setOpenDeleteSuccessModal}
        confirmationButtonColor="error"
      />

      <ActionAlert
        severity="success"
        open={openDeleteSuccessModal}
        setOpen={setOpenDeleteSuccessModal}

        message={"A usina foi deletado com sucesso!"
        }
        onClose={() => {
          setShowDeleteModal(false);
          navigate("/usinas");
        }}
      />
      <ActionAlert
        severity="error"
        open={openDeleteErrorModal}
        setOpen={setOpenDeleteErrorModal}
        message={
          "Ocorreu um erro ao deletar a usina!"
        }
        onClose={() => {
          setShowDeleteModal(false);
        }}
      />
    </Grid>
  );
}
